import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { routePaths } from 'router';
import { useGetManyTrips } from 'api/trips/use-get-many-trips.ts';
import { useMoveToPath } from 'shared/hooks/use-move-to-path';
import { useTripFiltersStore } from 'shared/stores/use-trip-filters.ts';
import { SearchFilter } from 'components/common/search-filter';
import styles from './trips-search.module.scss';

export const TripsSearch = () => {
  const [searchString, setSearchString] = useState('');
  const { setSearch } = useTripFiltersStore();
  const { moveToPath } = useMoveToPath();

  const { data: trips, isError } = useGetManyTrips({
    limit: 10,
    isHints: true,
    search: searchString,
    isSkip: !searchString,
  });

  const [options, setOptions] = useState<{ label: React.ReactNode; value: number }[]>([]);

  useEffect(() => {
    if (trips && !isError) {
      const values = trips.data.map((trip) => ({
        label: (
          <>
            <Typography.Text strong>{trip.compositeId}</Typography.Text>{' '}
            {trip.truck?.plateNumber ? (
              <Typography.Text className={styles.hintSecondaryInfo}> {trip.truck?.plateNumber}</Typography.Text>
            ) : null}
            {trip.trailer?.plateNumber || trip.trailerPlate ? (
              <Typography.Text className={styles.hintSecondaryInfo}>
                {' '}
                / {trip.trailer?.plateNumber || trip.trailerPlate}
              </Typography.Text>
            ) : null}
          </>
        ),
        value: trip.id,
      }));
      setOptions(values);
    } else {
      setOptions([]);
    }
  }, [trips, isError]);

  const handleSelect = (value: string) => {
    moveToPath(routePaths.trip, { tripId: value });
  };

  return (
    <SearchFilter
      options={options}
      setSearch={setSearch}
      setSearchString={setSearchString}
      selectHandler={handleSelect}
    />
  );
};
